import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import './store'
import vuetify from './plugins/vuetify'
import './plugins/moment'
import './plugins/apexcharts'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
